"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPixelsToMediaQueryEm = void 0;
const transformPixelsToMediaQueryEm = (x) => `${x / 16}em`;
exports.transformPixelsToMediaQueryEm = transformPixelsToMediaQueryEm;
//# sourceMappingURL=transformPixelsToMediaQueryEm.js.map